export default __webpack_public_path__ + "static/media/importer.9bb2ff06.svg";